import { Pressable, View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      width: '100%',
    },
    variants: {},
  }
})

export const Container = styled(Pressable, theme => {
  return {
    base: {
      minWidth: theme.sizingColossal + theme.sizingMicro,
      width: '100%',
    },
  }
})
